/**
 * This utility function returns a formated date
 *
 * Using locale "fr" the output would be : 10 février 2022
 */
function dateFormat(date, locale = "fr", options = {}) {
  const defaults = {
    year: "numeric",
    month: "long",
    day: "numeric",
  }
  return new Date(date).toLocaleDateString(locale, { ...defaults, ...options })
}

export default dateFormat
